import { DefaultService } from '@/services/DefaultService';

export default class AssPrazoPagamentoB2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, idEmpresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/b2b/b2bempresa/assprazopagto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idEmpresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/assprazopagto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    updateSituacao(assPrazoPagtoB2BEmpresa) {
        const { idb2b_assempresaprazopagto: idB2BAssEmpresaPrazoPagamento, ...rest } = assPrazoPagtoB2BEmpresa;

        return this._http.post(`${this._env}/b2b/b2bempresa/assprazopagto/updatesituacao`, { idB2BAssEmpresaPrazoPagamento, ...rest }, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    save(assPrazoPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/assprazopagto`, assPrazoPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    insertBulk(assPrazoPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/assprazopagto/insert-bulk`, assPrazoPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}